export default "__VITE_ASSET__T3sST4y4__"